import { useRef, useState } from "react";
import { Play } from "lucide-react";

const SRC = "/videos/webgenerator-promo.mp4";

export const PromoVideo = () => {
  const ref = useRef(null);
  const [started, setStarted] = useState(false);
  const start = () => {
    setStarted(true);
    ref.current?.play();
  };
  return (
    <section className="px-4 md:px-8 pb-20 md:pb-28" data-testid="promo-video-section">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-2xl sm:rounded-3xl bg-slate-900 p-1.5 sm:p-2 shadow-2xl shadow-indigo-500/20 ring-1 ring-slate-200">
          <div className="relative overflow-hidden rounded-xl sm:rounded-2xl bg-black aspect-video">
            <video
              ref={ref}
              src={`${SRC}#t=0.5`}
              preload="metadata"
              playsInline
              controls={started}
              className="h-full w-full object-cover"
              data-testid="promo-video"
            />
            {!started && (
              <button
                type="button"
                onClick={start}
                className="group absolute inset-0 flex flex-col items-center justify-center gap-4 bg-slate-900/40 transition-colors duration-300 hover:bg-slate-900/25"
                aria-label="Video abspielen"
                data-testid="promo-video-play-btn"
              >
                <span className="flex h-20 w-20 sm:h-24 sm:w-24 items-center justify-center rounded-full bg-white shadow-xl transition-transform duration-300 group-hover:scale-110">
                  <Play className="ml-1 h-8 w-8 sm:h-10 sm:w-10 fill-indigo-600 text-indigo-600" />
                </span>
                <span className="rounded-full bg-white/90 px-4 py-1.5 text-sm font-semibold text-slate-900 backdrop-blur-sm">
                  So einfach geht's – Video ansehen
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
